define('ResetPassword.Form.View', [
    'Backbone',
    'jQuery',
    'resetpassword_form.tpl'
], function (
    Backbone,
    jQuery,
    resetpasswordFormTpl
) {
    'use strict';

    return Backbone.View.extend({
        template: resetpasswordFormTpl,

        events: {
            'submit form': 'submitForm'
        },

        initialize: function initialize(options) {
            this.model = options.model;
            this.identity = options.identity;
            this.errorMessage = '';
            this.successMessage = '';
            this.isSubmitting = false;
        },

        submitForm: function submitForm(event) {
            var self = this;
            var password;
            var confirmPassword;

            event.preventDefault();
            password = this.$('[name="password"]').val() || '';
            confirmPassword = this.$('[name="confirm_password"]').val() || '';
            this.errorMessage = this.validatePassword(password, confirmPassword);
            this.successMessage = '';

            if (this.errorMessage) {
                this.render();
                return;
            }

            this.isSubmitting = true;
            this.render();
            this.model.resetPassword({
                email: this.identity.email,
                internalid: this.identity.internalid,
                recordtype: this.identity.recordtype,
                token: this.identity.token,
                password: password,
                confirm_password: confirmPassword
            }).done(function (response) {
                if (response && response.success) {
                    self.successMessage = 'Your password has been changed. You can now sign in.';
                } else {
                    self.errorMessage = response && response.message ?
                        response.message : 'We could not reset your password. Please request a new reset link.';
                }
            }).fail(function () {
                self.errorMessage = 'We could not reset your password. Please request a new reset link.';
            }).always(function () {
                self.isSubmitting = false;
                self.render();
            });
        },

        validatePassword: function validatePassword(password, confirmPassword) {
            if (password.length < 8) {
                return 'Your password must be at least 8 characters long.';
            }

            if (password !== confirmPassword) {
                return 'The passwords do not match.';
            }

            return '';
        },

        getContext: function getContext() {
            return {
                errorMessage: this.errorMessage,
                successMessage: this.successMessage,
                isSubmitting: this.isSubmitting
            };
        }
    });
});
